import { useQuery } from '@tanstack/react-query';
import { documentApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

/** @registry One document with its versions and activity trail. */
export function useDocument(
  jobId: number | null | undefined,
  documentId: string | null | undefined,
) {
  return useQuery({
    queryKey: queryKeys.documents.detail(jobId ?? -1, documentId ?? ''),
    queryFn: ({ signal }) =>
      documentApiClient.getDocumentById(
        jobId!,
        documentId!,
        toCancelToken(signal),
      ),
    enabled: jobId != null && jobId > 0 && !!documentId,
    staleTime: 0,
    meta: { errorContext: 'document detail' },
  });
}
